import React, { useEffect } from 'react';
import './index.css';
import { PortfolioData } from './types/portfolio';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Impact from './components/Impact';
import Experience from './components/Experience';
import Skills from './components/Skills';
import CaseStudies from './components/CaseStudies';
import Certifications from './components/Certifications';
import Education from './components/Education';
import Contact from './components/Contact';
import Footer from './components/Footer';
import portfolioData from './data/portfolio.json';

function App() {
  const data: PortfolioData = portfolioData;

  useEffect(() => {
    // Update document title and meta tags
    document.title = data.seo.title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', data.seo.description);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = data.seo.description;
      document.head.appendChild(meta);
    }
  }, [data]);

  return (
    <div className="min-h-screen bg-ivory">
      <Navigation data={data} />
      <main>
        <Hero data={data} />
        <section id="about">
          <About data={data} />
        </section>
        <section id="impact">
          <Impact data={data} />
        </section>
        <section id="experience">
          <Experience data={data} />
        </section>
        <section id="skills">
          <Skills data={data} />
        </section>
        <section id="work">
          <CaseStudies data={data} />
        </section>
        <section id="certifications">
          <Certifications data={data} />
        </section>
        <section id="education">
          <Education data={data} />
        </section>
        <section id="contact">
          <Contact data={data} />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;
